import { X } from 'lucide-react';
import type { JSX } from 'react';
import { useAnswerFor } from '../../agent/answer-for';
import { Button } from '../../components/Button/Button';
import { useTenantFeatures } from '../../hooks/useTenantFeatures';
import { TenantFeature } from '../../types/tenant.types';
import styles from './AnswerForControl.module.css';

/**
 * Who the assistant is writing for, when a page sent the person here with someone chosen: a support
 * ticket's customer, or a role picked in the knowledge base. There is no picker: nothing shows
 * until a page picks someone, and the chip then says who and clears back to the team's view. The
 * choice travels with every message (agent/answer-for.ts) and the server resolves it.
 */
export function AnswerForControl(): JSX.Element | null {
  const { hasFeature } = useTenantFeatures();
  return hasFeature(TenantFeature.SUPPORT) ? <AnswerForChip /> : null;
}

function AnswerForChip(): JSX.Element | null {
  const [answerFor, setAnswerFor] = useAnswerFor();
  if (!answerFor) return null;
  return (
    <div className={styles.Row}>
      <span className={styles.Caption}>Replying as</span>
      <span className={styles.Label}>{answerFor.label}</span>
      <Button
        type="button"
        variant="ghost"
        size="xs"
        forIconOnly
        className={styles.Clear}
        aria-label="Answer for your team instead"
        title="Answer for your team instead"
        onClick={() => setAnswerFor(null)}
      >
        <X aria-hidden="true" />
      </Button>
    </div>
  );
}

export default AnswerForControl;
